import React from "react";
import { RotateCw } from "lucide-react";
import { parApi } from "@/lib/partnerApi";
import { Empty, ErrorBox, Loading, useLoad } from "@/components/nds/windows/finance/parts";
import { useIsSuper } from "@/components/nds/windows/finance/InvoiceActions";
import ProgramStatsView from "@/components/nds/windows/partner/ProgramStatsView";
import ForecastReport from "@/components/nds/windows/partner/ForecastReport";
import { useAuth } from "@/lib/auth";

export default function ParProgramStatsContent() {
  const isSuper = useIsSuper();
  const { user } = useAuth();
  const isPartner = user?.role === "partner_user" && !!user?.partner_id;
  const [state, load] = useLoad(() => (isSuper ? parApi.get("/stats") : Promise.resolve(null)), [isSuper]);
  if (!isSuper && isPartner) return <div data-testid="par-stats-content" className="h-full overflow-y-auto p-5"><ForecastReport /></div>;
  if (!isSuper) return <Empty testid="par-stats-forbidden">Only a Super Admin can view program stats here.</Empty>;
  if (state.loading && !state.data) return <Loading testid="par-stats-loading" label="Loading stats…" />;
  if (state.error) return <ErrorBox testid="par-stats-error" error={state.error} onRetry={load} />;
  return (
    <div data-testid="par-stats-content" className="h-full overflow-y-auto p-5 space-y-4">
      <ForecastReport />
      <div className="flex items-center"><span className="font-mono text-[10px] tracking-[0.2em] uppercase text-nex-muted">Aggregate only · no individual resident data</span>
        <button type="button" onClick={load} data-testid="par-stats-refresh" aria-label="Refresh" className="ml-auto p-1.5 text-nex-muted hover:text-nex-gold"><RotateCw className="h-3.5 w-3.5" /></button></div>
      <ProgramStatsView s={state.data} />
    </div>
  );
}
